import {
  WORKFLOW_TRIGGERS,
  WORKFLOW_NODE_TYPES,
  NEW_WORKFLOW_ID,
} from 'modules/workflows/constants';
import { NewWorkflowForCreate, getNewWorkflowData } from 'modules/workflows/utils';
import { WorkflowType } from 'modules/workflows/enums';

export const getEditWorkflowDraftLink = (id: string | number) =>
  `/workflows/${id}/edit?workflowType=Draft`;

export const getEditWorkflowLink = (id: string | number) => `/workflows/${id}/edit`;

const startNodeOverrides = {
  nodeClass: WORKFLOW_TRIGGERS.TRIGGERED_BY_WORKFLOW,
  nodeSuperClass: WORKFLOW_NODE_TYPES.TRIGGER,
  nodeDescTop: 'Triggered by a Journey',
};

const workflowDraftData = getNewWorkflowData(
  NEW_WORKFLOW_ID,
  WorkflowType.DRAFT,
  startNodeOverrides,
);

export const getNewWorkflowDraftPayload = (name: string) => {
  const workflow = {
    ...workflowDraftData.data.workflow,
    name,
  } as NewWorkflowForCreate;

  workflow.nodes[0].workflowId = NEW_WORKFLOW_ID;
  return workflow;
};
